import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import InventoryIcon from "@mui/icons-material/Inventory";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import LogoutIcon from "@mui/icons-material/Logout";
import CompanyLogo from "../../images/logo.png";

const menuItems = [
  { text: "Dashboard", icon: <DashboardIcon />, path: "/" },
  { text: "Employees", icon: <PeopleIcon />, path: "/employees" },
  { text: "Salaries", icon: <MonetizationOnIcon />, path: "/salaries" },
  { text: "Office Inventory", icon: <InventoryIcon />, path: "/inventory" },
  { text: "Fitness Allowance", icon: <FitnessCenterIcon />, path: "/Fitness" },
  {
    text: "Medical Allowance",
    icon: <MedicalServicesIcon />,
    path: "/Medical",
  },
  { text: "Leaves", icon: <WorkOffIcon />, path: "/leaves" },
];

const HrSideNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  useEffect(() => {
    if (!isSmallScreen && drawerOpen) {
      setDrawerOpen(false);
    }
  }, [isSmallScreen, drawerOpen]);

  return (
    <>
      {!isSmallScreen ? (
        <Drawer
          variant="permanent"
          sx={{
            background: "#1C1D21",
            color: "white",
            width: "18vw",
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: "18vw",
              boxSizing: "border-box",
              background: "#1C1D21",
              color: "white",
            },
            "@media (max-width: 780px)": {
              width: 200,
              "& .MuiDrawer-paper": {
                width: 200,
              },
            },
          }}
        >
          <Box sx={{ p: 2 }}>
            <img src={CompanyLogo} alt="Company Logo" style={{ width: "80%" }} />
          </Box>

          <List>
            {menuItems.map((item, index) => (
              <div key={index}>
                <ListItem
                  button
                  component={Link}
                  to={item.path}
                  sx={{
                    color: "white",
                    borderLeft:
                      location.pathname === item.path
                        ? "4px solid #FF5722"
                        : "4px solid transparent",
                  }}
                >
                  <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItem>
                <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }} />
              </div>
            ))}
            <ListItem button onClick={() => setDialogOpen(true)}>
              <ListItemIcon sx={{ color: "white" }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </Drawer>
      ) : (
        <AppBar
          position="fixed"
          sx={{ backgroundColor: "#1C1D21", color: "white", boxShadow: "none", }}
        >
          <Toolbar sx={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            minHeight: { xs: '40px', sm: '40px' },
          }}>
            <>
              <IconButton
                color="inherit"
                edge="start"
                size="md"
                onClick={toggleDrawer(true)}
                sx={{ mr: 2 }}
              >
                <MenuIcon sx={{ fontSize: "35px" }} />
              </IconButton>
              <img
                src={CompanyLogo}
                alt="Company Logo"
                style={{ width: "180px" }}
              />
            </>
          </Toolbar>
        </AppBar>
      )}

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "60vw",
            backgroundColor: "#1C1D21",
            color: "white",
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <img src={CompanyLogo} alt="Company Logo" style={{ width: "60%" }} />
        </Box>
        <List>
          {menuItems.map((item, index) => (
            <div key={index}>
              <ListItem
                button
                component={Link}
                to={item.path}
                sx={{
                  color: "white",
                  borderLeft:
                    location.pathname === item.path
                      ? "4px solid #FF5722"
                      : "4px solid transparent",
                }}
                onClick={toggleDrawer(false)}
              >
                <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
              <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }} />
            </div>
          ))}
          <ListItem button onClick={() => setDialogOpen(true)}>
            <ListItemIcon sx={{ color: "white" }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#212121",
            color: "#fff",
            padding: "15px",
          },
          "& .MuiDialogTitle-root": {
            padding: "5px",
          },
          "& .MuiDialogContentText-root": {
            color: "#fff",
          },
          "& .MuiDialogContent-root": {
            padding: "10px",
          },
          "& .MuiDialogActions-root": {
            padding: "5px",
          },
        }}
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to Logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{
              backgroundColor: "#A6A6A6",
              color: "#fff",
              "&:hover": { backgroundColor: "#B8B8B8" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            sx={{
              backgroundColor: "#E5622D",
              color: "#fff",
              "&:hover": { backgroundColor: "#D0521B" },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HrSideNavBar;
